import { CustomFieldCompositionDto } from '@artemis-software/wr-api';
import UnitEnum = CustomFieldCompositionDto.UnitEnum;

export const UNIT_SYMBOLS: Record<UnitEnum, string> = {
  Meter: 'm',
  Centimeter: 'cm',
  Millimeter: 'mm',
  Kilogram: 'kg',
  Gram: 'g',
  Celsius: '°C',
  Liter: 'L',
  Milliliter: 'mL',
  SquareMeter: 'm²',
  Kilowatt: 'kW',
  KilowattHour: 'kWh',
  Bar: 'bar',
  Pascal: 'Pa',
  Percent: '%',
  Euro: '€',
  GermanHardness: '°dH',
  Tonne: 't',
  Megawatt: 'MW',
  MegawattHour: 'MWh',
  CubicMeter: 'm³',
  MicrosiemensPerCentimeter: 'µS/cm',
  MillimolPerLiter: 'mmol/l',
  MilligramPerLiter: 'mg/l',
  MilligramPerCubicMeter: 'mg/m³',
  LiterPerMinute: 'L/min',
  LiterPerHour: 'L/h',
  Volt: 'V',
  Ampere: 'A',
  Ohm: 'Ω',
  Kelvin: 'K',
  Hectopascal: 'hPa',
};

export function displayUnitSymbol(unit: UnitEnum | undefined): string {
  if (!unit) return '';
  return UNIT_SYMBOLS[unit] ?? unit;
}
